/**
 * Internal user detection.
 *
 * Controls whether a given email belongs to an internal RunPlutus operator
 * whose activity should be suppressed from analytics and session replay
 * tools so it does not pollute product metrics.
 */

export const INTERNAL_EMAIL_DOMAINS: readonly string[] = ["runplutus.com"];

export function isInternalUser(email?: string | null): boolean {
  if (!email) return false;
  const parts = email.toLowerCase().trim().split("@");
  if (parts.length !== 2) return false;
  const domain = parts[1];
  return INTERNAL_EMAIL_DOMAINS.includes(domain);
}
